import { useMemo } from "react";

// Simplified stylised outline of England & Wales (x: 0-100 west-east, y: 0-100 north-south)
const OUTLINE = [
    [37.3, 13.6], [46.7, 0.5], [49.3, 0.8], [52, 3.4], [56, 13.6], [61.3, 20.3],
    [70.7, 25.4], [77.3, 28.8], [74.7, 37.3], [80, 45.8], [78.7, 49.2], [88, 49.2],
    [98.7, 56], [93.3, 66], [88, 73], [94.7, 74.6], [93.3, 79.7], [88, 83],
    [74.7, 84.7], [61.3, 84.7], [50.7, 86.4], [42.7, 88], [36, 86.4], [21.3, 91.5],
    [6.7, 99.2], [0.5, 97.1], [5.3, 93.2], [13.3, 88.1], [16, 84.7], [21.3, 79.7],
    [29.3, 78], [33.3, 73], [24, 71.2], [18.7, 71.2], [13.3, 69.5], [5.3, 66.1],
    [13.3, 62.7], [21.3, 57.6], [21.3, 49.2], [13.3, 50.8], [16, 45.8], [18.7, 45.8],
    [25.3, 42.4], [33.3, 42.4], [34.7, 40.7], [36, 33.9], [37.3, 28.8], [33.3, 23.7],
    [30.7, 15.3],
];

const MANCHESTER = [46.1, 39.3];

const inside = (x, y) => {
    let hit = false;
    for (let i = 0, j = OUTLINE.length - 1; i < OUTLINE.length; j = i++) {
        const [xi, yi] = OUTLINE[i];
        const [xj, yj] = OUTLINE[j];
        if (yi > y !== yj > y && x < ((xj - xi) * (y - yi)) / (yj - yi) + xi) hit = !hit;
    }
    return hit;
};

export const CoverageMap = () => {
    const dots = useMemo(() => {
        const pts = [];
        const step = 3.6;
        let row = 0;
        for (let y = 1; y <= 100; y += step) {
            const offset = row % 2 === 0 ? 0 : step / 2;
            for (let x = offset; x <= 100; x += step) {
                if (inside(x, y)) pts.push([x, y]);
            }
            row++;
        }
        return pts;
    }, []);

    return (
        <div data-testid="coverage-map" className="relative">
            <svg viewBox="-4 -4 108 108" className="h-auto w-full" role="img" aria-label="Stylised map of England and Wales coverage area">
                {dots.map(([x, y], i) => (
                    <circle
                        key={i}
                        cx={x}
                        cy={y}
                        r={1.15}
                        fill={i % 13 === 0 ? "#059669" : "#334155"}
                        opacity={i % 13 === 0 ? 0.9 : 0.28}
                    />
                ))}
                <circle cx={MANCHESTER[0]} cy={MANCHESTER[1]} r={4.2} fill="none" stroke="#059669" strokeWidth={0.8} className="animate-pin-pulse" />
                <circle cx={MANCHESTER[0]} cy={MANCHESTER[1]} r={1.9} fill="#059669" stroke="#ffffff" strokeWidth={0.7} />
            </svg>
            <div className="mt-4 flex items-center gap-2 text-xs text-slate-500">
                <span className="inline-block h-2.5 w-2.5 rounded-full bg-emerald-600" />
                Registered Office — Manchester (correspondence address only)
            </div>
        </div>
    );
};
